module.exports = __webpack_public_path__ + "static/media/291819.2002d056.png";